export const inertHelper = (isActive: boolean) => {
    return isActive ? {} : { inert: '' };
};
